import { Text, TextStyle, Texture } from "pixi.js";
import { GameFont } from "../GameFont";
import { DefaultButton } from "./DefaultButton";
import { TextWithUnderline } from "../../game/components/TextWithUnderline";

export class PriceHistoryButton extends DefaultButton {
    private static readonly INFO_TEXT = "BUILDING PRICE HISTORY";

    private priceHistoryText: Text;

    public constructor(
        icon: Texture
    ) {
        super(icon);
        this.priceHistoryText = new TextWithUnderline(PriceHistoryButton.INFO_TEXT, new ButtonTextStyle());
        this.priceHistoryText.position.set(this.defaultView.width + 3, 10);
        this.addChild(this.priceHistoryText);
    }
}

class ButtonTextStyle extends TextStyle {
    public constructor() {
        super(
            new TextStyle({
                align: "center",
                fill: "#ffffff",
                fontFamily: GameFont.DEFAULT_FONT,
                fontSize: 32,
            })
        );
    }
}
